import React, { PureComponent } from 'react';
import { Accordion, Divider, Grid, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import shortid from 'short-id';
import { toast } from 'react-toastify';
import images from '../../../assets/Images';
import AdInfo from './AdInfo';
import { updateUrlComparerV2 } from '../../../utils/urls';
import * as AppActions from '../../../actions';
import {
  generateNewPreviewFromCreative,
  getColorRow,
  renderPopupQCOrCheckbox,
  renderNoteWarning,
  renderHoldAd,
  renderErrorReport,
  getEventSourceGroupName,
  checkIfAdIsForInstagram,
  getInstagramStoryByAdId
} from '../../../utils/ad.common';

class CompareContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ad: props.ad,
      originalAd: props.ad,
      secondAd: props.secondAd,
      originalSecondAd: props.secondAd,
      prevAd: props.ad,
      prevSecondAd: props.secondAd,
      token: props.getFbToken(),
      editId: '',
      copyLinkOpenFirst: false,
      copyLinkOpenSecond: false,
      copyAdIdOpenFirst: false,
      copyAdIdOpenSecond: false,
      eventGroupNames: null,
      instagramDataArray: []
    };

    this.fields = [
      'Year',
      'Month',
      'Client',
      'Campaign',
      'Audience',
      'Placements',
      'Ad Type',
      'Ad Name'
    ];
  }

  componentDidMount() {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    const activeIndex = params.ad;
    const adAccordionIndex = this.props.adAccordionIndex.toString();
    if (
      activeIndex === adAccordionIndex &&
      this.props.tabName === params.campaign
    ) {
      const id = `#accordion-${this.props.adAccordionIndex}-${
        this.props.tabName
      }`;
      if (document.querySelector(id)) {
        if (this.props.expandAll) {
          return null;
        }
        document.querySelector(id).scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    }
    const url = window.location.href;
    if (!url.includes('/compliance')) {
      const {
        ad,
        originalAd,
        secondAd,
        originalSecondAd,
        prevAd,
        prevSecondAd
      } = this.state;
      getEventSourceGroupName([
        ad,
        prevAd,
        originalAd,
        secondAd,
        prevSecondAd,
        originalSecondAd
      ]).then((results) => {
        this.setState({ eventGroupNames: results });
      });
    }
    this.determineIfAdsAreForInstagram();
    return null;
  }

  determineIfAdsAreForInstagram = async () => {
    const { ad, secondAd, token } = this.state;
    const adId = ad ? ad.ad_id : null;
    const secondAdId = secondAd ? secondAd.ad_id : null;
    if (adId) {
      const isInstagramAd = checkIfAdIsForInstagram(ad);
      if (isInstagramAd) {
        await getInstagramStoryByAdId(adId, token, this.setInstagramDataState);
      }
    }
    if (secondAdId) {
      const isInstagramAd = checkIfAdIsForInstagram(secondAd);
      if (isInstagramAd)
        await getInstagramStoryByAdId(
          secondAdId,
          token,
          this.setInstagramDataState
        );
    }
  };

  setInstagramDataState = (instagramData) => {
    const { originalAdId: idToCheck } = instagramData;
    const { instagramDataArray } = this.state;
    const newStateArray = instagramDataArray.filter((instagramAd) => {
      const { originalAdId: idToCompare } = instagramAd;
      return idToCheck !== idToCompare;
    });

    newStateArray.push(instagramData);

    this.setState((prevState) => ({
      ...prevState,
      instagramDataArray: newStateArray
    }));
  };

  returnInstagramDataFromStateArrayById = (adId) => {
    const { instagramDataArray } = this.state;
    const foundInstagramData = instagramDataArray.find((instagramAd) => {
      const { originalAdId } = instagramAd;
      return adId === originalAdId;
    });
    return foundInstagramData || {};
  };

  getValidationsArray = (fieldsValues, rules) => {
    return rules.map((rule) => {
      try {
        switch (rule.condition) {
          case 'Equals':
            return this.validateRuleContidion(fieldsValues, rule, 'equals');
          case 'Is Not Equal To':
            return !this.validateRuleContidion(fieldsValues, rule, 'equals');
          case 'Contains':
            return this.validateRuleContidion(fieldsValues, rule, 'includes');
          case 'Does Not Contain':
            return !this.validateRuleContidion(fieldsValues, rule, 'includes');
          case 'Is Empty':
            return rule.value.length === 0;
          case 'Is Not Empty':
            return rule.value.length > 0;
          default:
            return this.validateRuleContidion(fieldsValues, rule, 'equals');
        }
      } catch (e) {
        return false;
      }
    });
  };

  setEditId = (editId) => {
    this.setState({
      editId
    });
  };

  handleLinkClose = (source) => {
    this.setState({
      [`copyLinkOpen${source}`]: false
    });
    clearTimeout(this.timeout);
  };

  handleLinkOpen = (source) => {
    this.setState({
      [`copyLinkOpen${source}`]: true
    });
    this.handleGenerateCopyLink();
    this.timeout = setTimeout(() => {
      this.setState({
        [`copyLinkOpen${source}`]: false
      });
    }, 2500);
    return null;
  };

  handleGenerateCopyLink = () => {
    const link = window.location.href;

    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(link);
    }

    return link;
  };

  handleAccordionClick = (index, campaignKey) => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    const { accordionIndex } = this.props;
    if (accordionIndex[campaignKey] === index) {
      this.props.actions.adPreviewAdAccordionIndex(-1, campaignKey);
      updateUrlComparerV2({
        ...params,
        ad: '',
        campaign: campaignKey
      });
    } else {
      this.props.actions.adPreviewAdAccordionIndex(index, campaignKey);
      updateUrlComparerV2({
        ...params,
        ad: index,
        campaign: campaignKey
      });
    }
  };

  handleAdIdHover = (source) => {
    this.setState({
      [`copyAdIdOpen${source}`]: true
    });
    this.timeout = setTimeout(() => {
      this.setState({ adIdOpen: false });
    }, 2500);
  };

  handleAdIdClick = (source) => {
    let previewAdId = '';

    if (source === 'First') {
      const { ad } = this.state;
      previewAdId = ad.ad_id || '';
    }

    if (source === 'Second') {
      const { secondAd } = this.state;
      previewAdId = secondAd.ad_id || '';
    }

    this.setState({
      [`copyAdIdOpen${source}`]: true
    });

    this.generateCopyAdId(previewAdId);

    this.timeout = setTimeout(() => {
      this.setState({ [`copyAdIdOpen${source}`]: false });
    }, 1250);

    toast(`Ad ID: ${previewAdId} copied to clipboard!`, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 2500,
      type: toast.TYPE.WARNING,
      hideProgressBar: false
    });
  };

  handleAdIdClose = (source) => {
    this.setState({ [`copyAdIdOpen${source}`]: false });
    clearTimeout(this.timeout);
  };

  generateCopyAdId = (adId) => {
    if (navigator && navigator.clipboard && adId !== '') {
      navigator.clipboard.writeText(adId);
    }
    return adId;
  };

  updateCompareAd = (newAd) => {
    const { ad, secondAd } = this.state;

    if (ad && ad.ad_id === newAd.ad_id) {
      this.setState({
        ad: newAd,
        prevAd: newAd
      });
    } else if (secondAd && secondAd.ad_id === newAd.ad_id) {
      this.setState({
        secondAd: newAd,
        prevSecondAd: newAd
      });
    }
  };
  updatePreview = (newAd) => {
    const { ad, secondAd, token } = this.state;

    if (ad && ad.ad_id === newAd.ad_id) {
      generateNewPreviewFromCreative(newAd, token).then((preview) => {
        this.setState({
          ad: {
            ...newAd,
            desktop_iframe_url: preview.desktop,
            mobile_iframe_url: preview.mobile
          }
        });
      });
    } else if (secondAd && secondAd.ad_id === newAd.ad_id) {
      generateNewPreviewFromCreative(newAd, token).then((preview) => {
        this.setState({
          secondAd: {
            ...newAd,
            desktop_iframe_url: preview.desktop,
            mobile_iframe_url: preview.mobile
          }
        });
      });
    }
  };
  cancellingFacebookAd = (adId) => {
    const { prevAd, prevSecondAd } = this.state;

    if (prevAd && prevAd.ad_id === adId) {
      this.setState({
        ad: prevAd
      });
    } else if (prevSecondAd && prevSecondAd.ad_id === adId) {
      this.setState({
        secondAd: prevSecondAd
      });
    }
  };
  checkAdOrSecondAd = (ad, secondAd) => {
    if (ad) {
      return ad;
    }
    return secondAd;
  };

  refreshPreview = (ad) => {
    if (ad && ad.ad_id === this.state.ad.ad_id) {
      this.setState({
        ad: {
          ...this.state.ad,
          desktop_iframe_url: ad.desktop_iframe_url,
          mobile_iframe_url: ad.mobile_iframe_url
        }
      });
    } else if (ad && ad.ad_id === this.state.secondAd.ad_id) {
      this.setState({
        secondAd: {
          ...this.state.secondAd,
          desktop_iframe_url: ad.desktop_iframe_url,
          mobile_iframe_url: ad.mobile_iframe_url
        }
      });
    }
  };

  isUTMFormat = (name, tags) => {
    let result = {
      result: false,
      status: 'question'
    };
    const utms = this.props.utms;
    const _fields = name.split('_');

    const fieldsValues = {};
    _fields.map((field, i) => {
      fieldsValues[this.fields[i]] = field;
      return null;
    });

    if (utms) {
      for (const key in utms) {
        if (utms[key].status === 'active') {
          const { rules } = utms[key];
          const _ands = rules.filter((rule) => rule.operator === 'AND');
          const _ors = rules.filter((rule) => rule.operator === 'OR');
          const _andsArray = this.getValidationsArray(fieldsValues, _ands);
          const _orsArray = this.getValidationsArray(fieldsValues, _ors);
          const isValidAnds =
            !_andsArray.includes(false) && _andsArray.length > 0;
          const isValidOrs = !_orsArray.includes(false) && _orsArray.length > 0;
          const isValid = isValidAnds || isValidOrs;

          if (isValid) {
            if (utms[key].code === tags) {
              result = {
                result: true,
                status: 'noTag'
              };
            } else {
              result = {
                result: false,
                status: 'tag'
              };
            }
            break;
          }
        }
      }
    }

    return result;
  };

  validateRuleContidion = (fieldsValues, rule, condition) => {
    if (condition === 'equals') {
      return (
        fieldsValues[rule.field].toLowerCase() === rule.value.toLowerCase()
      );
    }

    return fieldsValues[rule.field]
      .toLowerCase()
      .includes(rule.value.toLowerCase());
  };

  render() {
    const {
      ad,
      secondAd,
      originalAd,
      originalSecondAd,
      eventGroupNames,
      editId,
      copyLinkOpenFirst,
      copyAdIdOpenFirst,
      copyLinkOpenSecond,
      copyAdIdOpenSecond
    } = this.state;
    const {
      adAccordionIndex,
      accordionIndex,
      tabName,
      getFbToken,
      expandAll,
      adsSection,
      editMode,
      flipping,
      adAccountName
    } = this.props;
    const index = adAccordionIndex;
    const activeIndex = accordionIndex[tabName];
    let esgNameFirst = '';
    let esgNameSecond = '';
    if (ad) {
      ad.displayCheckmark = true;
      if (
        ad.lineageInfo === undefined ||
        ad.lineageInfo === null ||
        ad.lineageInfo.adId === undefined
      ) {
        ad.lineageInfo = {};
        ad.displayCheckmark = false;
      }
      if (eventGroupNames) {
        const foundEsgObj = eventGroupNames.find((esgObj) => {
          return esgObj.ad_id === ad.ad_id;
        });
        esgNameFirst = foundEsgObj ? foundEsgObj.esgName : '';
      }
    }
    if (secondAd) {
      secondAd.displayCheckmark = true;
      if (
        secondAd.lineageInfo === undefined ||
        secondAd.lineageInfo === null ||
        secondAd.lineageInfo.adId === undefined
      ) {
        secondAd.lineageInfo = {};
        secondAd.displayCheckmark = false;
      }
      if (eventGroupNames) {
        const foundEsgObj = eventGroupNames.find((esgObj) => {
          return esgObj.ad_id === secondAd.ad_id;
        });
        esgNameSecond = foundEsgObj ? foundEsgObj.esgName : '';
      }
    }

    const colorFirstRow = getColorRow(ad);
    const colorSecondRow = getColorRow(secondAd);
    const isFormatedFirst =
      ad && this.isUTMFormat(ad.ad_original_name, ad.url_tags);
    const isFormatedSecond =
      secondAd &&
      this.isUTMFormat(secondAd.ad_original_name, secondAd.url_tags);
    const isHoldFirst = ad && ad.adQc && ad.adQc.on_hold;
    const isHoldSecond = secondAd && secondAd.adQc && secondAd.adQc.on_hold;

    return (
      <div
        key={this.props.key}
        id={`accordion-${index}-${this.props.tabName}`}
        className="accordion-item"
      >
        <div className="container-lists">
          <Grid>
            <Grid.Row>
              <Grid.Column width={8} className="custom-column">
                <div className="ad-list">
                  {ad ? (
                    <Accordion styled>
                      <div>
                        <Accordion.Title
                          style={{
                            background: colorFirstRow,
                            color: colorFirstRow ? 'white' : null
                          }}
                          active={activeIndex === index || this.props.expandAll}
                          index={index}
                          onClick={() =>
                            this.handleAccordionClick(index, this.props.tabName)
                          }
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column
                                width={isFormatedFirst.result ? 12 : 11}
                              >
                                <Icon name="dropdown" /> {ad.ad_name}{' '}
                                {ad.displayCheckmark ? (
                                  <img
                                    src={images.lineageCheckmark}
                                    className="lineage-checkmark"
                                    alt="lineage checkmark"
                                  />
                                ) : null}{' '}
                              </Grid.Column>{' '}
                              <Grid.Column
                                width={isFormatedFirst.result ? 4 : 5}
                                textAlign="right"
                              >
                                {' '}
                                {!isFormatedFirst.result && (
                                  <Icon
                                    name={
                                      isFormatedFirst.status === 'tag'
                                        ? 'tag'
                                        : 'question'
                                    }
                                    color={isHoldFirst ? 'grey' : 'red'}
                                    style={{
                                      marginRight: 30,
                                      verticalAlign: 'unset'
                                    }}
                                    size="large"
                                  />
                                )}{' '}
                                {renderErrorReport(ad)} {renderHoldAd(ad)}{' '}
                                {renderNoteWarning(ad)}{' '}
                                {renderPopupQCOrCheckbox(ad, 'qc1')}{' '}
                                {renderPopupQCOrCheckbox(ad, 'qc2')}{' '}
                              </Grid.Column>{' '}
                            </Grid.Row>{' '}
                          </Grid>{' '}
                        </Accordion.Title>{' '}
                        <Accordion.Content
                          active={activeIndex === index || expandAll}
                        >
                          <AdInfo
                            refreshPreview={this.refreshPreview}
                            editId={editId}
                            setEditId={this.setEditId}
                            getFbToken={getFbToken}
                            key={ad.ad_id}
                            ad={ad}
                            originalAd={originalAd}
                            adSection={adsSection}
                            editMode={editMode}
                            flipping={flipping}
                            adToCompare={secondAd}
                            parentAdId={ad.lineageInfo.parentAdId}
                            updateCompareAd={this.updateCompareAd}
                            updatePreview={this.updatePreview}
                            cancellingFacebookAd={this.cancellingFacebookAd}
                            tabName={tabName}
                            linkSource="First"
                            copyLinkOpen={copyLinkOpenFirst}
                            handleLinkOpen={this.handleLinkOpen}
                            handleLinkClose={this.handleLinkClose}
                            adIdText={`Ad ID: ${ad.ad_id}`}
                            copyAdIdOpen={copyAdIdOpenFirst}
                            handleAdIdClick={this.handleAdIdClick}
                            handleAdIdHover={this.handleAdIdHover}
                            handleAdIdClose={this.handleAdIdClose}
                            utms={this.props.utms}
                            isFormated={isFormatedFirst.result}
                            generateCopyLink={this.handleGenerateCopyLink}
                            adAccountName={adAccountName}
                            eventSourceGroupName={esgNameFirst}
                            isInstagramAd={checkIfAdIsForInstagram(ad)}
                            instagramData={this.returnInstagramDataFromStateArrayById(
                              ad.ad_id
                            )}
                          />{' '}
                        </Accordion.Content>{' '}
                      </div>{' '}
                    </Accordion>
                  ) : (
                    <div>
                      {' '}
                      There is not match to this Ad: {secondAd.ad_name}{' '}
                    </div>
                  )}{' '}
                </div>{' '}
              </Grid.Column>{' '}
              <Grid.Column width={8} className="custom-column">
                <div className="ad-list">
                  {' '}
                  {secondAd ? (
                    <Accordion styled>
                      <div>
                        <Accordion.Title
                          style={{
                            background: colorSecondRow,
                            color: colorSecondRow ? 'white' : null
                          }}
                          active={activeIndex === index || this.props.expandAll}
                          index={index}
                          onClick={() =>
                            this.handleAccordionClick(index, this.props.tabName)
                          }
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column
                                width={isFormatedSecond.result ? 12 : 11}
                              >
                                <Icon name="dropdown" /> {secondAd.ad_name}{' '}
                                {secondAd.displayCheckmark ? (
                                  <img
                                    src={images.lineageCheckmark}
                                    className="lineage-checkmark"
                                    alt="lineage checkmark"
                                  />
                                ) : null}{' '}
                              </Grid.Column>{' '}
                              <Grid.Column
                                width={isFormatedSecond.result ? 4 : 5}
                                textAlign="right"
                              >
                                {' '}
                                {!isFormatedSecond.result && (
                                  <Icon
                                    name={
                                      isFormatedSecond.status === 'tag'
                                        ? 'tag'
                                        : 'question'
                                    }
                                    color={isHoldSecond ? 'grey' : 'red'}
                                    style={{
                                      marginRight: 30,
                                      verticalAlign: 'unset'
                                    }}
                                    size="large"
                                  />
                                )}{' '}
                                {renderErrorReport(secondAd)}{' '}
                                {renderHoldAd(secondAd)}{' '}
                                {renderNoteWarning(secondAd)}{' '}
                                {renderPopupQCOrCheckbox(secondAd, 'qc1')}{' '}
                                {renderPopupQCOrCheckbox(secondAd, 'qc2')}{' '}
                              </Grid.Column>{' '}
                            </Grid.Row>{' '}
                          </Grid>{' '}
                        </Accordion.Title>{' '}
                        <Accordion.Content
                          active={activeIndex === index || this.props.expandAll}
                        >
                          <AdInfo
                            refreshPreview={this.refreshPreview}
                            editId={this.editId}
                            setEditId={this.setEditId}
                            getFbToken={this.props.getFbToken}
                            key={secondAd ? secondAd.ad_id : shortid.generate()}
                            ad={secondAd}
                            originalAd={originalSecondAd}
                            adSection={adsSection}
                            editMode={editMode}
                            flipping={flipping}
                            adToCompare={ad}
                            parentAdId={secondAd.lineageInfo.parentAdId}
                            updateCompareAd={this.updateCompareAd}
                            updatePreview={this.updatePreview}
                            cancellingFacebookAd={this.cancellingFacebookAd}
                            tabName={tabName}
                            linkSource="Second"
                            copyLinkOpen={copyLinkOpenSecond}
                            handleLinkOpen={this.handleLinkOpen}
                            handleLinkClose={this.handleLinkClose}
                            adIdText={
                              secondAd
                                ? `Ad ID: ${secondAd.ad_id}`
                                : `Ad ID: ${shortid.generate()}`
                            }
                            copyAdIdOpen={copyAdIdOpenSecond}
                            handleAdIdClick={this.handleAdIdClick}
                            handleAdIdHover={this.handleAdIdHover}
                            handleAdIdClose={this.handleAdIdClose}
                            utms={this.props.utms}
                            isFormated={isFormatedSecond.result}
                            generateCopyLink={this.handleGenerateCopyLink}
                            adAccountName={adAccountName}
                            eventSourceGroupName={esgNameSecond}
                            isInstagramAd={checkIfAdIsForInstagram(secondAd)}
                            instagramData={this.returnInstagramDataFromStateArrayById(
                              secondAd.ad_id
                            )}
                          />{' '}
                        </Accordion.Content>{' '}
                      </div>{' '}
                    </Accordion>
                  ) : (
                    <div> There is not match to this Ad: {ad.ad_name} </div>
                  )}{' '}
                </div>{' '}
              </Grid.Column>{' '}
            </Grid.Row>{' '}
          </Grid>{' '}
        </div>{' '}
        <Divider hidden />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  expandAll: state.adPreview.expandAllAds,
  accordionIndex: state.adPreview.accordionIndex
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareContainer);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/CompareContainer.js